import { BASE_URL } from './constants';

export default (ApiService) => ({
  getStatus() {
    return ApiService.query(`${BASE_URL}/status`);
  },
  startSync(batchSize) {
    const url = batchSize ? `${BASE_URL}?batchSize=${batchSize}` : BASE_URL;
    return ApiService.post(url, {});
  },
  listRuns(params = {}) {
    return ApiService.query(`${BASE_URL}/runs`, { params });
  },
  listBatches(runId) {
    return ApiService.query(`${BASE_URL}/runs/${runId}/batches`);
  },
  listMutationFailures(params = {}) {
    return ApiService.query(`${BASE_URL}/mutation-failures`, { params });
  },
});
